import { FormattedMessage } from 'react-intl';

import { SelectPropertyDropdown } from '../select-property-dropdown';
import { messages } from './messages';

import type { TextWidget, PropertyOptions, HorizontalTextAlignType, WidgetPropertyInput, WidgetPropertyDefinition } from '../../../config';

const options: PropertyOptions<HorizontalTextAlignType> = [
  {
    name: <FormattedMessage {...messages.left} />,
    key: 'left',
  },
  {
    name: <FormattedMessage {...messages.center} />,
    key: 'center',
  },
  {
    name: <FormattedMessage {...messages.right} />,
    key: 'right',
  },
];

const HorizontalTextAlignment = (props: WidgetPropertyInput<TextWidget>) => (
  <SelectPropertyDropdown options={options} property='horizontalAlign' {...props} />
);

export const HorizontalTextAlignmentProperty: WidgetPropertyDefinition<TextWidget> = {
  id: 'horizontal-text-alignment',
  label: <FormattedMessage {...messages.label} />,
  Component: HorizontalTextAlignment,
};
